import { render, staticRenderFns } from "./Masiva.vue?vue&type=template&id=24d67998&scoped=true&"
import script from "./Masiva.vue?vue&type=script&lang=js&"
export * from "./Masiva.vue?vue&type=script&lang=js&"
import style0 from "./Masiva.vue?vue&type=style&index=0&id=24d67998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d67998",
  null
  
)

export default component.exports